// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Space, Styled} from '@supermove/components';
import {Form} from '@supermove/hooks';
import {colors} from '@supermove/styles';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';
import Text from '@shared/design/components/Text';

const Container = Styled.View`
`;

const EstimatedHoursRowContainer = Styled.View`
  flex-direction: row;
  align-items: center;
`;

const EstimateHoursField = ({
  field,
  form,
  handleEnter,
}: {
  field: string;
  form: Form;
  handleEnter: () => void;
}) => {
  const {errors, touched} = form;
  const minEstimateFieldName = `${field}.minEstimateHoursValueForm.amount`;
  const maxEstimateFieldName = `${field}.maxEstimateHoursValueForm.amount`;
  const errorMessage1 = _.get(errors, minEstimateFieldName);
  const errorMessage2 = _.get(errors, maxEstimateFieldName);
  const isTouched1 = !!_.get(touched, minEstimateFieldName);
  const isTouched2 = !!_.get(touched, maxEstimateFieldName);
  const error1 = isTouched1 && errorMessage1;
  const error2 = isTouched2 && errorMessage2;
  const errorMessage = error1 || error2;

  return (
    <Container>
      <EstimatedHoursRowContainer>
        <FieldInput
          {...form}
          name={minEstimateFieldName}
          input={{
            placeholder: 'Est. min',
            keyboardType: 'numeric',
            autoFocus: true,
          }}
          showErrorMessage={false}
          handleEnter={handleEnter}
          style={{flex: 1}}
        />
        <Space width={8} />
        <Text.Body>-</Text.Body>
        <Space width={8} />
        <FieldInput
          {...form}
          name={maxEstimateFieldName}
          input={{
            placeholder: 'Est. max',
            keyboardType: 'numeric',
          }}
          handleEnter={handleEnter}
          showErrorMessage={false}
          style={{flex: 1}}
        />
      </EstimatedHoursRowContainer>
      {errorMessage && (
        <React.Fragment>
          <Space height={4} />
          <Text.Body style={{color: colors.red.warning}}>{errorMessage}</Text.Body>
        </React.Fragment>
      )}
    </Container>
  );
};

export default EstimateHoursField;
